<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>

            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>




                    <v-layout wrap>
                      <div class="flex md12">

                        <div v-show="codegorunum === true ">
                          <v-text-field :color="color" label="Kredi Kart No" mask="####-####-####-####" v-model="Firma.KrediKartNo"
                            :error-messages="errors.collect('kartno')" v-validate="'required|min:16'" data-vv-name="kartno"
                            required>
                          </v-text-field>
                        </div>

                        <v-select :items="karttipi" :color="color" clearable v-model="Firma.KrediKartTip"
                          :error-messages="errors.collect('selectkarttipi')" v-validate="'required'" data-vv-name="selectkarttipi"
                          label="Kredi Kartı Tipi" item-text="text" item-value="id"></v-select>

                        <v-select :items="sonkullanimAy" :color="color" clearable v-model="Firma.Ay" :error-messages="errors.collect('selectsonkullanim')"
                          v-validate="'required'" data-vv-name="selectsonkullanim" label=" Kredi Kart Son Kullanım Ay"
                          item-text="text" item-value="id"></v-select>

                        <v-select :items="sonkullanimYil" :color="color" clearable v-model="Firma.Yil" :error-messages="errors.collect('selectsonkullanimyil')"
                          v-validate="'required'" data-vv-name="selectsonkullanimyil" label=" Kredi Kart Son Kullanım Yıl"
                          item-text="text" item-value="id"></v-select>


                        <v-text-field label="Muhasebe Kodu" :color="color" v-model="Firma.MuhasebeKodu" :error-messages="errors.collect('muhkod')"
                          v-validate="'required'" data-vv-name="muhkod" required>
                        </v-text-field>

                        <v-autocomplete label="Cari Seçiniz" :color="color" clearable append-icon="search" :loading="loading"
                          :items="state" item-text="text" cache-items="" item-value="id" :search-input.sync="search"
                          v-model="Firma.CariKod" :error-messages="errors.collect('kartcari')" v-validate="'required'"
                          data-vv-name="kartcari"></v-autocomplete>

                        <v-text-field label="Banka Kodu" :color="color" v-model="Firma.BankaKod" :error-messages="errors.collect('bankkod')"
                          v-validate="'required'" data-vv-name="bankkod" required>
                        </v-text-field>
                      </div>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deletefirma()">Sil</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="baslikfont">Firma Kart</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn flat @click="kartekle()"> Firma Kart Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="items" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.KrediKartNo)" item>
            <td class="text-xs-left">{{ props.item.KrediKartNo }}</td>
            <td class="text-xs-left">{{ props.item.Ay }}</td>
            <td class="text-xs-left">{{ props.item.Yil }}</td>
            <td class="text-xs-left">{{ props.item.KrediKartTip }}</td>
            <td class="text-xs-left">{{ props.item.CariKod }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Kart Numarası',
            value: 'KrediKartNo'
          },
          {
            text: 'Ay',
            value: 'Ay'
          },
          {
            text: 'Yıl',
            value: 'Yil'
          },
          {
            text: 'Kart Tipi',
            value: 'KrediKartTip'
          },
          {
            text: 'Cari Kodu',
            value: 'CariKod'
          },

        ],
        loading: false,
        items: [],
        search: null,
        select: [],
        karttipi: [{
            id: 'M',
            text: 'Master Card'
          },
          {
            id: 'VI',
            text: 'VISA'
          },
          {
            id: 'A',
            text: 'American Express'
          },
        ],
        sonkullanimAy: [{
            id: '01',
            text: '1'
          },
          {
            id: '02',
            text: '2'
          },
          {
            id: '03',
            text: '3'
          },
          {
            id: '04',
            text: '4'
          },
          {
            id: '05',
            text: '5'
          },
          {
            id: '06',
            text: '6'
          },
          {
            id: '07',
            text: '7'
          },
          {
            id: '08',
            text: '8'
          },
          {
            id: '09',
            text: '9'
          },
          {
            id: '10',
            text: '10'
          },
          {
            id: '11',
            text: '11'
          },
          {
            id: '12',
            text: '12'
          }
        ],
        sonkullanimYil: [
          '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017',
          '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'
        ],
        selected: '',
        m: false,
        k: false,
        color: 'info',
        dialog: false,
        search3: '',
        Firma: {
          KrediKartTip: '',
          Ay: '',
          Yil: '',
          KrediKartNo: '',
          CariKod: '',
          MuhasebeKodu: '',
          BankaKod: '',
        },
        cari: '',
        state: [],
        progress: false,
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        kartno: '',
        selectkarttipi: '',
        selectsonkullanim: '',
        selectsonkullanimyil: '',
        muhkod: '',
        kartcari: '',
        bankkod: '',
        dictionary: {
          custom: {
            kartno: {
              required: () => 'Bu alan boş bırakılamaz',
              min: 'Kart numarası 16 haneli olmalıdır.'
            },
            name1: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            selectkarttipi: {
              required: () => 'lütfen seçiminizi yapınız',
            },
            kartcari: {
              required: () => 'lütfen seçiminizi yapınız',
            },
            selectsonkullanim: {
              required: () => 'lütfen seçiminizi yapınız',
            },
            selectsonkullanimyil: {
              required: () => 'lütfen seçiminizi yapınız',
            },
            muhkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            bankkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }

    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Firma Kartı Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          SirketKodu: credentials.SirketKodu,
          KrediKartNo: v
        }
        this.$http.post(auth.API_URL + 'api/FirmCard/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Firma = response.body
          this.search = response.body.CariKod
        })
      },
      deletefirma: deletefirma,
      kartekle: kartekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      carigetir: carigetir,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
  }

  function vazgec() {
    this.dialog = false
    this.search = ''
    this.kartcari = null
    this.selectkarttipi = ''
    this.selectsonkullanim = ''
    this.selectsonkullanimyil = ''
    this.Firma.MuhasebeKodu = ''
    this.Firma.BankaKod = ''
    this.Firma.KrediKartNo = ''
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.state = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          SirketKodu: credentials.SirketKodu,
        }

        var params = this.Firma
        this.$http.post(auth.API_URL + 'api/FirmCard/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }

  function kartekle() {
    this.dialog = true
    this.Firma = {}
    this.dialog_baslik = 'Firma Kart Ekle'
    this.selectkarttipi = ''
    this.selectsonkullanim = ''
    this.selectsonkullanimyil = ''
    this.Firma.MuhasebeKodu = ''
    this.Firma.BankaKod = ''
    this.Firma.KrediKartNo = ''
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()


  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      SirketKodu: credentials.SirketKodu,
    }
    this.progress = true
    this.$http.post(auth.API_URL + 'api/FirmCard/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false

        this.text1 = 'Kayıt Bulunamadı'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })
  }

  function deletefirma() {
    if (window.confirm('Firma Kartını\'ı silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params1 = {
        SirketKodu: credentials.SirketKodu,
      }
      var params = this.Firma
      this.$http.post(auth.API_URL + 'api/FirmCard/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          SirketKodu: credentials.SirketKodu,
        }

        var params = this.Firma
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/FirmCard/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/FirmCard/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>